import { useEffect, useState } from 'react';
export function useDebounceValue(value, delayMs = 250) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(handler);
  }, [delayMs, value]);
  return debouncedValue;
}